import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import {
    googleMapInit,
    googleMapClose,
    googleMapChangeZoom,
    googleMapChangeUrl,
    googleMapChangeSatelliteView,
    googleMapCheckboxChange,
    googleMapChangeStreetViewUrl,
    googleMapToggleExpandedStreetView,
} from './actions'

function mapStateToProps(state, hocProps) {
    const id = _.get(hocProps, 'id')

    return {
        activeAddressZoom: state.getIn(['ui', 'googleMap', id, 'activeAddressZoom']),
        showRegistered: state.getIn(['ui', 'googleMap', id, 'showRegistered']),
        showBranch: state.getIn(['ui', 'googleMap', id, 'showBranch']),
        showShops: state.getIn(['ui', 'googleMap', id, 'showShops']),
        streetViewExpanded: state.getIn(['ui', 'googleMap', id, 'streetViewExpanded']),
        mapUrl: state.getIn(['ui', 'googleMap', id, 'mapUrl']),
        streetViewUrl: state.getIn(['ui', 'googleMap', id, 'streetViewUrl']),
        satelliteView: state.getIn(['ui', 'googleMap', id, 'satelliteView']),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            googleMapInit,
            googleMapClose,
            googleMapChangeZoom,
            googleMapChangeUrl,
            googleMapChangeSatelliteView,
            googleMapCheckboxChange,
            googleMapChangeStreetViewUrl,
            googleMapToggleExpandedStreetView,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
